const state = {
  news: [],
  poster: null
};

export default state;